import type { ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell.js';
import { useAuth } from './lib/auth.js';
import { ApiHealthPage } from './pages/ApiHealthPage.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { LiveCallPage } from './pages/LiveCallPage.js';
import { OrgSetupPage } from './pages/OrgSetupPage.js';
import { PostCallPage } from './pages/PostCallPage.js';
import { RunDetailPage } from './pages/RunDetailPage.js';
import { RunsPage } from './pages/RunsPage.js';
import { SalesforceLoginWindow } from './pages/SalesforceLoginWindow.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { SignInPage } from './pages/SignInPage.js';

export function App(): ReactNode {
  const auth = useAuth();

  if (auth.loading) {
    return (
      <div className="signin">
        <p className="muted">Checking your session…</p>
      </div>
    );
  }

  if (auth.required && !auth.user) {
    return <SignInPage allowedDomain={auth.allowedDomain} />;
  }

  return (
    <Routes>
      <Route path="salesforce-login" element={<SalesforceLoginWindow />} />
      <Route element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="api-health" element={<ApiHealthPage />} />
        <Route path="org-setup" element={<OrgSetupPage />} />
        <Route path="live-call" element={<LiveCallPage />} />
        <Route path="post-call" element={<PostCallPage />} />
        <Route path="runs" element={<RunsPage />} />
        <Route path="runs/:runId" element={<RunDetailPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
